/*
 * Sportsact: antal ved siden af "Læg i kurv" (snippets/custom-quantity-inline.liquid).
 * Renderes kun på produkter uden Mængderabat – her flyttes vælgeren blot op i rækken ved siden af knappen.
 */
class CustomQuantityInline extends HTMLElement {
  connectedCallback() {
    // Kaldes igen, når vælgeren flyttes op til knappen
    if (this.hasAttribute('data-placed')) {
      return;
    }

    const form = document.getElementById(this.getAttribute('form'));
    const row = form?.querySelector('buy-buttons')?.parentElement;

    if (!row) {
      return;
    }

    this.setAttribute('data-placed', '');
    row.classList.add('custom-quantity-inline__row');
    row.prepend(this);
    this.hidden = false;
  }
}

if (!window.customElements.get('custom-quantity-inline')) {
  window.customElements.define('custom-quantity-inline', CustomQuantityInline);
}
